module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "el",
    class: _vm.className
  }, [_c('div', {
    class: ("content-timeline " + (_vm.milestone.color))
  }, [_c('div', {
    staticClass: "milestone-img"
  }, [_c('img', {
    attrs: {
      "src": ("/static/images/origins-of-type/" + (_vm.milestone.img)),
      "alt": ("" + (_vm.milestone.alt))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "milestone-content"
  }, [_c('div', {
    staticClass: "caps"
  }, [_c('span', {
    staticClass: "bold bottom-br"
  }, [_vm._v(_vm._s(_vm.milestone.year))]), _vm._v(" "), _c('h3', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.milestone.title))])]), _vm._v(" "), _c('p', {
    staticClass: "serif"
  }, [_vm._v(_vm._s(_vm.milestone.caption))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c3d4803","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Milestone.vue
// module id = 135
// module chunks = 0